import type { AppointmentSignatureDoc } from '@bb/domain/dist/schemas';
import type { BuildJsonType } from '@bb/domain/dist/typeHelpers';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type GetAppointmentSignatureOptions = {
  appointmentId: string;
};

export type GetAppointmentSignatureResponse =
  BuildJsonType<AppointmentSignatureDoc>;

const getAppointmentSignature = async ({
  appointmentId,
}: GetAppointmentSignatureOptions) => {
  const config: AxiosRequestConfig = {
    url: `/covid19/appointment/${appointmentId}/settings`,
    method: 'get',
  };

  const { data } = await axios.request<GetAppointmentSignatureResponse>(config);

  return data;
};

export default getAppointmentSignature;
